import {
  type ECarrierVendorType,
  type ICarrierService,
} from '@mahawi/eshop-common/src/types';
import { createSlice } from '@reduxjs/toolkit';

import {
  asyncStateInitial,
  finishLoading,
  requestFailedMatcher,
  resetLoadingOnRequestFailed,
  startLoading,
} from '../async-state';
import { type ICarrierState } from './types';

export const preloadedState: ICarrierState = {
  ...asyncStateInitial,
  carrierServices: undefined,
};

const carrierSlice = createSlice({
  name: 'Carrier',
  initialState: preloadedState,
  reducers: {
    carrierServicesLoad(state) {
      startLoading(state);
      state.carrierServices = undefined;
    },
    carrierServicesLoadAllResponse: {
      reducer(
        state,
        action: { payload: { carrierServices: ICarrierService[] } },
      ) {
        state.carrierServices = action.payload.carrierServices;
        finishLoading(state);
      },
      prepare(carrierServices: ICarrierService[]) {
        return { payload: { carrierServices } };
      },
    },
    carrierCreatePacket: {
      reducer() {},
      prepare(
        orderUuid: string,
        carrierVendorCode: string,
        carrierServiceThirdPartyId: string,
      ) {
        return {
          payload: {
            order: { uuid: orderUuid },
            carrierService: { thirdPartyId: carrierServiceThirdPartyId },
            carrierVendor: { code: carrierVendorCode as ECarrierVendorType },
          },
        };
      },
    },
    carrierSyncPacketStatus: {
      reducer() {},
      prepare(
        packetThirdPartyId: string,
        orderUuid: string,
        carrierVendorCode: ECarrierVendorType,
      ) {
        return {
          payload: {
            packet: { thirdPartyId: packetThirdPartyId },
            order: { uuid: orderUuid },
            carrierVendor: { code: carrierVendorCode },
          },
        };
      },
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      requestFailedMatcher('Carrier'),
      resetLoadingOnRequestFailed,
    );
  },
});

export const {
  carrierServicesLoad,
  carrierServicesLoadAllResponse,
  carrierCreatePacket,
  carrierSyncPacketStatus,
} = carrierSlice.actions;
export default carrierSlice.reducer;
